// extracted by mini-css-extract-plugin
module.exports = {"image":"styles-module--image--2nJVj","modalImage":"styles-module--modalImage--c7oEF"};